import { jsx as _jsx } from "react/jsx-runtime";
import PCol from 'shared/ui/pcol';
import React, { memo } from 'react';
export const GroupLabel = memo((props) => (_jsx(PCol, { col: "12", children: _jsx("div", { className: "group-header", children: _jsx("strong", { children: props.label }) }) })));
export default GroupLabel;
